import { Theme } from '@mui/material';

// MUI's sx prop resolves these keys through its spacing system: a numeric
// value is multiplied by theme.spacing() (e.g. 1 -> '8px' with the default
// 8px unit), while a string passes through unchanged. Components that accept
// these shorthand props outside of sx must reproduce that resolution manually.
export const LAYOUT_SPACING_PROP_NAMES = [
  'mb',
  'mt',
  'ml',
  'mr',
  'pt',
  'pb',
  'pl',
  'pr',
  'margin',
  'padding',
] as const;

export const LAYOUT_PROP_NAMES = [...LAYOUT_SPACING_PROP_NAMES, 'width'];

export interface LayoutSpacingProps {
  readonly mb?: string | number;
  readonly mt?: string | number;
  readonly ml?: string | number;
  readonly mr?: string | number;
  readonly pt?: string | number;
  readonly pb?: string | number;
  readonly pl?: string | number;
  readonly pr?: string | number;
  readonly margin?: string | number;
  readonly padding?: string | number;
}

export interface LayoutProps extends LayoutSpacingProps {
  readonly width?: string | number;
}

export const toSpacing = (theme: Theme, value?: string | number) =>
  typeof value === 'number' ? theme.spacing(value) : value;

export const shouldForwardLayoutProp = (prop: string) =>
  !LAYOUT_PROP_NAMES.includes(prop);

export const resolveLayoutStyles = (
  theme: Theme,
  { mb, mt, ml, mr, pt, pb, pl, pr, margin, padding, width }: LayoutProps,
) => ({
  marginBottom: toSpacing(theme, mb),
  marginTop: toSpacing(theme, mt),
  marginLeft: toSpacing(theme, ml),
  marginRight: toSpacing(theme, mr),
  paddingTop: toSpacing(theme, pt),
  paddingBottom: toSpacing(theme, pb),
  paddingLeft: toSpacing(theme, pl),
  paddingRight: toSpacing(theme, pr),
  margin: toSpacing(theme, margin),
  padding: toSpacing(theme, padding),
  width,
});
